<template>
  <v-dialog v-model="value" persistent max-width="600px">
    <material-card color="primary" :title="title" :text="item.name">
      <v-form ref="form" v-model="validForm">
        <v-container style="max-width:1450px">
          <v-layout wrap>
            <v-flex xs12 sm5 md5>
              <v-select
                md4
                clearable
                v-model="choosedTreatment"
                :items="protocolTreatments"
                color="primary"
                hide-no-data
                item-text="drug"
                item-value="id"
                label="Treatment"
                return-object
              >
                <template slot="item" slot-scope="{ item }">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.drug }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{
                      item.dose
                    }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-select>
            </v-flex>

            <v-flex xs12 sm5 md5>
              <v-text-field
                :label="'Dose ' + measure_unit"
                v-model="item.dose"
              ></v-text-field>
            </v-flex>

          
            <v-flex xs12 sm2 md2>
              <!--v-btn @click="remove" text icon color="pink">
                <v-icon>mdi-delete</v-icon>
              </v-btn-->

              <v-btn
                class="mx-1 font-weight-light"
                color="purple"
                :disabled="!checkSave() && !validForm"
                @click="save()"
                >Save</v-btn>
            </v-flex>

          </v-layout>
        </v-container>
      </v-form>


      <v-data-table
        :items="pregnancyTreatments"
        hide-headers
        hide-actions
      >
      <template slot="items" slot-scope="{ item }" >
        <td class="text-xs-left">{{ item.treatment.drug }}</td>
        <td class="text-xs-left">{{ item.dose }}</td>
        <td class="text-xs-right">
          <a flat @click="remove(item)">
            <v-icon color="primary">mdi-delete</v-icon>
          </a></td>
      </template>
    </v-data-table>
  

      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="close()"
          >Close</v-btn
        >
      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>
import { getList as getProtocolTreatments } from "@/api/treatment";
import { getList, upsert, getDetail, remove as removeprtr} from "@/api/pregnancy_has_treatment";
import validators from "@/utils/validators";

export default {
  inheritAttrs: false,
  props: {
    value: Boolean,
    pregnancy: Object
  },
  data() {
    return {
      menu_datePicker_last_administration: false,
      validForm: true,
      validators,
      treatment: undefined,
      loadingTreatment: false,
      pregnancyTreatments: [],
      item: {},
      protocolTreatments: [],
      choosedTreatment: null,
      actions: [
        "Dose not changed",
        "Dose reduced",
        "Drug suspended",
        "Drug withdrawn",
        "Unknown"
      ],
      relationships: [
        "Definitely related",
        "Probably related",
        "Possilbly related",
        "Unlikely to be related",
        "Not related",
        "Unknown"
      ]
    };
  },
  mounted() {
    
  },
  watch: {
    choosedTreatment(v) {
      if (v) {
        this.item.treatment_id = v.id;
      }
    },
    value(v) {
      if (v) {
        
        this.$refs.form.reset();
        this.item.pregnancy_id = this.pregnancy.id;
        this.item.protocol_id = this.pregnancy.protocol_id;

        getProtocolTreatments(
          { protocol_id: this.item.protocol_id },
          { rowsPerPage: null }
        ).then(data => {
          this.protocolTreatments = data.data;
        });
        this.getData();
      }
    }
  },
  computed: {
    isNew() {
      return this.item.id ? false : true;
    },
    title() {
      return "Treatments for Pregnancy (" + this.pregnancy.cin + ")";
    },
    measure_unit() {
      if (this.choosedTreatment) {
        return "(" + this.choosedTreatment.measure_unit + ")";
      } else {
        return "";
      }
    }
  },
  methods: {
    getData() {
      getList({pregnancy_id: this.pregnancy.id}, {sortBy:"insert_at", descending:true}).then( data => {
        this.pregnancyTreatments = data.data;
      });
    },
    close() {
      this.$emit("input", false);
    },
    checkSave() {
      return !this.isNew;
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error"
        });
        return;
      }
      upsert(this.item)
        .then(data => {
          this.$store.dispatch("app/openSnackbar", {
            message: "Pregnancy treatment updated correctly",
            color: "success"
          });
          this.getData();
        })
        .catch(e => {
          this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the Pregnancy treatment update. " +
              e.response.data.message,
            color: "error"
          });
        });
    },
    remove(aeTr) {
      removeprtr(aeTr).then( data => {
        this.getData();
      });
    }
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
